import React from "react";
import ProductCard from "./ProductCard";
import ScrollReveal, { revealItemProps } from "../common/Reveal";

function ProductGrid({ products, showAddToCart = false }) {
  if (!products.length) return null;

  return (
    <ScrollReveal stagger className="caf-product-grid">
      {products.map((product, index) => (
        <div key={product.id} {...revealItemProps(index, "min-w-0 h-full")}>
          <ProductCard product={product} showAddToCart={showAddToCart} />
        </div>
      ))}
    </ScrollReveal>
  );
}

ProductGrid.revealManaged = true;

export default ProductGrid;
